export class ScenarioVersion {
    public scenario_version_id: number;
    public scenario_id: number;
    public user_id: number;
    public name: string;
    public scenario_data: string;
    public main:number;
    public autosave:number;
    public created: string;
    public modified: string;

  constructor(
    scenario_version_id: number,
    scenario_id: number,
    user_id: number,
    name: string,
    scenario_data: string,
    main: number,
    autosave: number,
    created: string,
    modified: string,
  ) {
    this.scenario_version_id = scenario_version_id;
    this.scenario_id = scenario_id;
    this.user_id = user_id;
    this.name = name;
    this.scenario_data = scenario_data;
    this.main = main;
    this.autosave = autosave;
    this.created = created;
    this.modified = modified;
  }
}
